import {
  FETCH_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR,
} from './constants';

const initialState = {
  isFetching: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DATA:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        ...action.data,
      };
    case FETCH_DATA_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
